<div class="annotation-list">
  <rdrx-annotation-list-header
    [headerClass]="(emptyTree$ | async) || (sessionEnded$ | async)"
    [type]="headerType"
    [isEditMode]="isEditMode"
    [areAllAnnotationsSelected]="allAnnotationsSelected"
    (dropdownOptionSelected)="handleDropdownState($event)"
    (editModeSelected)="handleEditMode($event)"
    (allAnnotationsSelected)="handleAllAnnotationsSelected($event)"
    (exportAnnotationsSelected)="beginExport()"
  ></rdrx-annotation-list-header>

  <div class="content">

    <p *ngIf="emptyTree$ | async" class="list-empty-msg" translate>contents.highlight_blank</p>
    <mhe-alert *ngIf="sessionEnded$ | async" [smallAlert]="true" [type]="AlertType.Warning" [closable]="false">
      {{ 'contents.highlight_session_error' | translate }}
    </mhe-alert>
    <div class="export-alert" *ngIf="exportStatus$ | async">
      <mhe-alert [smallAlert]="true" [type]="AlertType.Info" [closable]="true">
        {{ 'export.in_progress' | translate }}
      </mhe-alert>
    </div>

    <ngx-bonsai
      class="rdrx"
      rdrxBonsaiTabIndex data-automation-id="highlights-group"
      [nodesById]="nodeTree$ | async | orphanAnnotationsFilter:highlightDropDownState()"
      [rootNodeId]="rootNodeId"
      [expandedNodes]="higlightListStore.expandedNodes$ | async"
      [showToggleFn]="isCollapsible"
      [isLoading]="isLoading"
      (expanderClick)="toggleNodeExpanded($event)"
    >
      <ng-template #treeNodeTemplate let-node>
        <div
          mheStopPropagation
          rdrxBonsaiNodeSelect
          class="annotation-item highlight"
          data-automation-id="highlights-children"
          [rdrxBonsaiNodeSelectKeyboard]="!node.collapsible"
          (click)="handleNodeClick(node)"
        >
          <mhe-checkbox
            *ngIf="isEditMode && !node.collapsible"
            id="check-annotation"
            [checked]="isNodeChecked(node)"
            (change)="handleCheckAnnotation(node)"
          >&nbsp;</mhe-checkbox>
          <div
            *ngIf="node.annotation"
            [ngClass]="{'image': !isEditMode }"
          >
            <div *ngIf="node.annotation.orphan; else highlight">
              <img
                id='unlink-icon'
                src="/assets/icons/reader/unlink.svg"
                alt="Unlink Icon"
                width="30px"
                [mheTooltip]="'context.detached_highlight' | translate"
                [placement]="'right'">
            </div>

            <ng-template #highlight>
              <rdrx-highlight-icon [color]="node.annotation?.color" [shape]="node.annotation?.shape"></rdrx-highlight-icon>
            </ng-template>
          </div>

          <div class="title">
            <p
              *ngIf="node.annotation?.orphan"
              class="orphan-highlight-msg"
            >
              {{ 'contents.orphan_highlight_msg' | translate }}
            </p>
            <span class="date" *ngIf="node.annotation?.updatedAt">
              {{ node.annotation?.updatedAt | date : 'shortDate' }}
            </span>
            <span id="expandable-highlight-{{ node.id }}" (text)="handleTextChange($event, node)" rdrxTruncate>
            {{ node.title }}
            </span>
          </div>
          <button
            *ngIf="!node.collapsible"
            class="trashcan"
            mhe-button
            data-automation-id="remove-annotation-highlight"
            [disabled]="higlightListStore.readonly$ | async"
            [purpose]="ButtonPurpose.Icon"
            [mheStopPropagation]="['click', 'keydown.Enter', 'keydown.Space']"
            rdrxHideOnEscape
            [mheTooltip]="'context.remove_highlight' | translate"
            [alternateAriaLabel]="('context.remove_highlight' | translate) + ' ' + node.ariaLabel"
            (click)="delete(node.annotation)">
            <i class="dpg-icon dpg-icon-trash"></i>
          </button>
        </div>
      </ng-template>
      <ng-template #loadingTemplate>
        <mat-progress-spinner
          class="rdrx-spinner spine-annotations-loading"
          mode="indeterminate"
          [strokeWidth]="2"
          [diameter]="75"
        ></mat-progress-spinner>
      </ng-template>
    </ngx-bonsai>
  </div>
  <rdrx-annotation-list-footer
    *ngIf="isEditMode"
    class="rdrx-annotation-list-footer"
    [disableDeleteBtn]="!isFooterBtnDisabled"
    (deleteClick)="handleDeleteClick()"
    (cancelClick)="handleCancelClick()"
  ></rdrx-annotation-list-footer>
</div>
